import { propertiesTypes } from '@/reports/types';

export function sortDeeds(
  deedA: propertiesTypes.Deeds[number],
  deedB: propertiesTypes.Deeds[number]
) {
  const dateDeedA = deedA?.transfer?.recorder?.date?.full || 0;
  const dateDeedB = deedB?.transfer?.recorder?.date?.full || 0;
  const dateA = new Date(dateDeedA).getTime();
  const dateB = new Date(dateDeedB).getTime();
  return dateB - dateA;
}
